import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { getPassengerLabel } from '@common/helpers';
import { PaymentDetailsData } from '@common/interfaces/reservation-basic-information-input/reservation-basic-information-input.interface';
import { ServiceRequestPaymentInputService } from '@common/services/service-request-payment-input/service-request-payment-input-service';
import { SupportComponent } from '@lib/components/support-class';
import { AmountFormatPipe, StaticMsgPipe } from '@lib/pipes';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-payment-details-paid-service',
  templateUrl: './payment-details-paid-service.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentDetailsPaidServiceComponent extends SupportComponent implements AfterViewInit {
  @ViewChildren('passengers') passengers!: QueryList<ElementRef>;

  get paymentDetailsList(): Array<PaymentDetailsData> {
    return this._serviceRequestPaymentInputService.paymentDetailsList;
  }

  notEligibleForPaymentLabel: string = 'label.notEligibleForPayment';

  constructor(
    private _common: CommonLibService,
    private _serviceRequestPaymentInputService: ServiceRequestPaymentInputService,
    private _staticMsg: StaticMsgPipe,
    private _amountFormatPipe: AmountFormatPipe
  ) {
    super(_common);
  }

  override init(): void {
    /* override abstract init function of base class */
  }

  ngAfterViewInit(): void {
    const maxHeight = Math.max(...this.passengers.map((item) => item.nativeElement.offsetHeight));
    this.passengers.forEach((item) => (item.nativeElement.style.height = maxHeight + 'px'));
  }
  // [9.10] 購入サービス一覧
  getPassengerTypeLabel(passengerType: string | undefined): string {
    return getPassengerLabel(passengerType ?? '');
  }

  getAmount(amountByService?: string): string {
    if (amountByService === this.notEligibleForPaymentLabel)
      return this._staticMsg.transform(this.notEligibleForPaymentLabel);
    const amount = Number(amountByService ?? '');
    if (amountByService && !isNaN(amount)) {
      return this._amountFormatPipe.transform(Number(amount));
    }
    return '';
  }

  override reload(): void {
    /* override abstract reload function of base class */
  }

  override destroy(): void {
    /* override abstract destroy function of base class */
  }
}
